import { Component, computed, inject } from '@angular/core';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './navigation/navigation.component';
import { NavigationService } from '../services/navigation.service';
import { AppstateService } from '../services/appstate.service';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {

  // 330px sidnav + 10px round corner
  public sidenavWidth = computed(() => (this.appStateService.sidenavExpanded() ? '316px' : '110px'));

  constructor(public appStateService: AppstateService) {

  }

}
